"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PageWidth = function PageWidth(_ref) {
  var formProps = _ref.formProps;
  var setPageWidth = function setPageWidth(pageWidth) {
    // Need to deep copy to force formProps.dirty and a re-render
    formProps.setValues(_objectSpread(_objectSpread({}, formProps.values), {}, {
      courseDescription: _objectSpread(_objectSpread({}, formProps.values.courseDescription), {}, {
        pageWidth: pageWidth
      })
    }));
  };
  var currentValue = formProps.values.courseDescription && formProps.values.courseDescription.pageWidth;
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: _style["default"].fieldset
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].fieldsetHeading
  }, "Page Width"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "btn-group ".concat(_style["default"].pageWidthButtons),
    role: "group"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn ".concat(currentValue === 'small' ? 'btn-primary' : 'btn-secondary'),
    onClick: function onClick() {
      return setPageWidth('small');
    }
  }, "Small"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn ".concat(currentValue === 'medium' ? 'btn-primary' : 'btn-secondary'),
    onClick: function onClick() {
      return setPageWidth('medium');
    }
  }, "Medium"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn ".concat(currentValue === 'large' ? 'btn-primary' : 'btn-secondary'),
    onClick: function onClick() {
      return setPageWidth('large');
    }
  }, "Large")));
};
var _default = exports["default"] = PageWidth;